module.exports = __webpack_public_path__ + "static/media/Viren-nanavati.46836115.png";